<app-header title="SDS" subTitle=""></app-header>

<div class="main-container">
    <!-- <span class="heading">SDS Search</span> -->
    <div class="options-container">
        <form [formGroup]="searchForm" novalidate>
            <div class="mb-3 flex">
                
                <div>
                    <span class="px-3 font-semibold">Language</span>
                    <p-dropdown [options]="languages" optionLabel="name"
                        [dropdownIcon]="isDropdownsFetching ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'"
                        formControlName="selectedLanguage" class="ng-dirty"></p-dropdown>
                </div>
                <div>
                    <span class="px-3 font-semibold">Country</span>
                    <p-dropdown [options]="countries" optionLabel="name"
                        [dropdownIcon]="isDropdownsFetching ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'"
                        formControlName="selectedCountry" class="ng-dirty"></p-dropdown>
                </div>

                <div>
                    <span class="px-3 font-semibold">Material Code</span>
                    <input type="text" pInputText  placeholder="Search by material code." formControlName="materialValue" />
                </div>
            </div>
            <div class="px-3 flex justify-content-start ">
                <div class="w-8">
                    <input type="text" pInputText class="w-12"
                        placeholder="Search by product or title or name. See the help button if you need more info." formControlName="textValue"  />
                    <div class="error" *ngIf="!searchFormValid"> Search with product code,title or name...</div>
                </div>
                <p-button class="ml-3" label="Submit" (click)="handleGetSearchList(0,true)" [disabled]="isDropdownsFetching || isLanguageFetching"></p-button>
                <p-button class="ml-2" label="Clear" (click)="clearText()"></p-button>
            </div>
        </form>
    </div>
    <div class="home__content"  *ngIf="!searchPerformed">
        <div class="home__text">
            <p class="Welcome_home__text">Welcome back!</p>
            <p class="welcome_home__subtext">Please search with a product to retrieve SDS</p>
        </div>
        <div class="home__img">
            <img class="home___image" loading="lazy" src="../../../../assets/welcome_img.png" alt="flask image" />
        </div>
    </div>
    <div *ngIf="searchPerformed">
        <!-- Check if products array is empty -->
        <div *ngIf="products.length === 0" class="no_result__text">
            <div class="home__img">
                <img class="no_result___image" loading="lazy" src="../../../../assets/no_result.png" alt="no result image" />
            </div>
            <div class="no_result_text">
                No results found
            </div>
            <div class="no_result__subtext">
                Try adjusting your search or filter to find what you are looking for
            </div>
        </div>

        <!-- Display table only if products array is not empty -->
        <div class="card" *ngIf="products.length > 0"> 
        <p-table [tableStyle]="{'min-width': '50rem'}"[resizableColumns]="true" columnResizeMode="expand" 

         [responsive]="true"  [value]="products" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true"  [rows]="rowsPerPage"
            class="main-table" [(first)]="firstIndex" [columns]="columns" [showCurrentPageReport]="true"
            [totalRecords]="totalRecords"
            currentPageReportTemplate="{{firstIndex}} - {{lastIndex}} of {totalRecords}" [alwaysShowPaginator]="true" [lazy]="true"
            (onPage)="paginate($event)" [loading]="isSearchListFetching" [loadingIcon]="'pi pi-spinner pi-spin'">
            <ng-template pTemplate="header">
                <tr class="custom-header">
                    <th  pResizableColumn *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : null"  class="table-header"  [ngClass]="{'custom-col-material-code':col.name=='Material Code'}" [ngStyle]="{'text-align': col.field === 'download' ? 'center' : 'left'}">
                        {{ col.name }}
                        <p-sortIcon *ngIf="col.sortable" [field]="col.field" (click)="onSort(col.field)" class="custom-sort-icon"></p-sortIcon>
                      </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr>
                    <!-- <td pTooltip="{{product?.title||''}}" [ngClass]="{'blue-text': true}">{{ product?.title||"" }}</td> -->
                    <td [ngClass]="{'col-text-v': true}"  pTooltip="{{product?.productName||''}}">{{ product?.productName||"" }}</td>
                    <td [ngClass]="{'col-text': true}">{{ product?.countryName||"" }}</td>
                    <td [ngClass]="{'col-text': true}">{{ product?.language||"" }}</td>
                    <td [ngClass]="{'col-text-v': true}">{{ product?.version||"" }}</td>
                    <td style="width: 5%" pTooltip="{{product?.materialCode1||product?.materialCode2||''}}">{{
                        product?.materialCode1||product?.materialCode2||"" }}</td>
                    <td [ngClass]="{'col-text': true}">{{ product?.date||"" }}</td>
                    <td [ngClass]="{'col-text': true}">{{ product?.gbuEnterprise||"" }}</td>
                    <td [ngClass]="{'col-text': true}">{{ product?.productCode||"" }}</td>
                    <td>
                        <div [ngClass]="{'blue-text-btn': true}"><i class="pi pi-download" (click)="downloadSDS(product?.title,product?.docid,product?.productName,product?.date,product?.version,product?.pdfTitle)"></i></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div>

    </div>
</div>